import { render } from "./itemsbestbuyprods.vue?vue&type=template&id=1af1647e"
import script from "./itemsbestbuyprods.vue?vue&type=script&lang=js"
export * from "./itemsbestbuyprods.vue?vue&type=script&lang=js"

import exportComponent from "C:\\CEDIS\\cedispage2.0_general_guvi\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__